const industries = [
  { id: "manufacturing", label: "Manufacturing", icon: "manufacturing" },
  { id: "retail-ecommerce", label: "Retail & eCommerce", icon: "retail" },
  { id: "healthcare", label: "Healthcare", icon: "healthcare" },
  { id: "education", label: "Education", icon: "education" },
  { id: "finance", label: "Finance", icon: "finance" },
  { id: "logistics", label: "Logistics & Transport", icon: "logistics" },
  { id: "real-estate", label: "Real Estate", icon: "realestate" },
  { id: "pharma", label: "Pharmaceuticals", icon: "pharma" },
  { id: "telecom", label: "Telecom & ISP", icon: "telecom" },
];

export default industries;
